$(document).ready(function () {
	const $counters = $('.counter');
	const speed = 100;

	if (!$counters.length) {
		return;
	}

	const animateCount = ($counter) => {
		const target = +$counter.data('target');

		const updateCount = () => {
			const count = +$counter.text().replace(/,/g, '');
			const increment = target / speed;

			if (count < target) {
				$counter.text(Math.ceil(count + increment).toLocaleString('en'));
				setTimeout(updateCount, 10);
			}
			else {
				$counter.text(target.toLocaleString('en'));
			}
		};

		updateCount();
	};

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				$(entry.target).addClass('visible');
				animateCount($(entry.target));
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.1
	});

	$counters.each(function () {
		observer.observe(this);
	});
});
